import { pythonAxios } from './http';

// eslint-disable-next-line import/prefer-default-export
export const getCitiesApi = ({ params = {} } = {}) =>
  pythonAxios.get('/geocode', {
    params,
  });
